/**
 * Roll options grouped by domain, as Foundry keeps them in `actor.rollOptions`. The "all" domain
 * is included in every query.
 */
export class RollOptions {
  #domains = new Map<string, Map<string, boolean>>();

  set(domain: string, option: string, value = true): void {
    let record = this.#domains.get(domain);
    if (!record) {
      record = new Map();
      this.#domains.set(domain, record);
    }
    record.set(option, value);
  }

  delete(domain: string, option: string): void {
    this.#domains.get(domain)?.delete(option);
  }

  has(domain: string, option: string): boolean {
    return this.#domains.get(domain)?.get(option) === true;
  }

  /** Every enabled option in "all" plus the requested domains. */
  get(domains: Iterable<string> = []): Set<string> {
    const options = new Set<string>();
    for (const domain of new Set(["all", ...domains])) {
      const record = this.#domains.get(domain);
      if (!record) continue;
      for (const [option, enabled] of record) if (enabled) options.add(option);
    }
    return options;
  }

  toJSON(): Record<string, string[]> {
    const out: Record<string, string[]> = {};
    for (const [domain, record] of this.#domains) {
      const enabled = [...record].filter(([, v]) => v).map(([k]) => k).sort();
      if (enabled.length > 0) out[domain] = enabled;
    }
    return out;
  }
}
